module.exports = __webpack_public_path__ + "images/category_lp/furniture/assessment_achievements/6@2x_e67499966ed9fffb2a4c8bcc27858f08.png";